import { useMutation, useQueryClient } from 'react-query';

import { UpdateDocChronDocFactsRequestDto } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/update-doc-chron-doc-facts-request.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateDocChronologyDocFactsParameters extends UpdateDocChronDocFactsRequestDto {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
  docId: string;
}

interface HookProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpdateDocChronologyDocFacts = ({ onSuccess, onError }: HookProps = {}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ matterId, subsetId, docChronologyId, docId, factIds }: UpdateDocChronologyDocFactsParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          factIds,
        } satisfies UpdateDocChronDocFactsRequestDto,
      });

      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}/docs/${docId}/facts`,
        fetchConfig,
      );

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([QueryEntity.DocChronologyDocs, { docChronologyId: variables.docChronologyId }]);
        onSuccess?.();
      },
      onError: (error: Error) => {
        onError?.(error);
      },
    },
  );
};
